import dayjs from "dayjs";

export const formatDate = (timestamp) => {
  const date = dayjs();
  return date.format("DD/MM/YYYY hh:mm");

  // const date = new Date(timestamp);
  // const day = ("0" + date.getDate()).slice(-2);
  // const month = ("0" + (date.getMonth() + 1)).slice(-2);
  // const year = date.getFullYear().toString().slice(-2);
  // const hours = ("0" + date.getHours()).slice(-2);
  // const minutes = ("0" + date.getMinutes()).slice(-2);

  // return day + "." + month + "." + year + " " + hours + ":" + minutes;
};
